/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';

import styled from 'react-emotion';

import { GridArea } from '../../layouts/helpers';

const MobileGrid = styled.div`
  display: grid;
  grid-template:
    'image          title            title' auto
    'image          rating           rating' auto
    'image          priceInfo        gift' auto
    'follow         payment          payment' auto
    'hRule          hRule            hRule' auto
    'shipping       shipping         shipping' auto
    'cartActions    cartActions      cartActions' auto
    / 100px auto auto;

  grid-column-gap: ${props => props.theme.new.spacer}px;
  grid-row-gap: ${props => props.theme.new.spacer}px;
`;

const MobileContent = props => (
  <Fragment>
    <GridArea gridArea="image">{props.logo}</GridArea>
    <GridArea gridArea="title" leftAligned>
      {props.title}
    </GridArea>
    <GridArea gridArea="priceInfo" leftAligned spaceBetween={0.5}>
      {props.discount}
      {props.price}
      {props.stockLabel}
    </GridArea>
    <GridArea gridArea="rating" leftAligned>
      {props.rating}
    </GridArea>
    <GridArea gridArea="follow" leftAligned>
      {props.follow}
    </GridArea>
    <GridArea gridArea="gift" rightAligned>
      {props.gift}
    </GridArea>
    <GridArea gridArea="payment" bottomJustified>
      {props.payment}
    </GridArea>
    <GridArea gridArea="hRule">{props.hRule}</GridArea>
    <GridArea gridArea="shipping" leftAligned paddingBottom={1}>
      {props.shipping}
    </GridArea>
    <GridArea gridArea="cartActions" spaceBetweenJustified>
      {props.cartActions}
    </GridArea>
  </Fragment>
);

const MobileView = props => (
  <MobileGrid>
    <MobileContent {...props} />
  </MobileGrid>
);

export default MobileView;
